import { makeStyles } from '@material-ui/core';
import { themeColor } from '../../mui-theme';

export const styles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: 2,
    background: themeColor.modalBackground,
    maxWidth: '56.85vw',
  },
}));
